import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import {
	$,
	mutation,
} from "../../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../../shared/shared/api-client";

export function voidPayByLink({
	apiClient,
	...variables
}: {
	apiClient: ApiClient;
} & VariablesOf<typeof voidPayByLink.gql.voidPayByLink>) {
	return safe(() =>
		apiClient.request(voidPayByLink.gql.voidPayByLink, variables),
	);
}

voidPayByLink.gql = {
	voidPayByLink: mutation("voidPayByLink", (q) => [
		q.voidPayByLink({
			deviceUuid: $("deviceId"),
			entityUuid: $("entityId"),
			id: $("ecommerceId"),
		}),
	]),
};
